import React from "react";
import { Outlet, Route, Routes } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Header from "../components/common/header";
import Sidebar from "../components/common/sidebar";
import { useAppSelector } from "../store/store";
import routePermissions from "./routePermissions";

const ErrorPage = React.lazy(() => import("./../screens/general/ErrorPage"));

const ALLRoutes = () => {
  const user = useAppSelector((state) => state.user.data);
  const pageMap = useAppSelector((state) => state.user.pageMap);

  const HeaderLayout = () => (
    <>
      <Header />
      <Sidebar />
      <Outlet />
    </>
  );
  function getPagePermissions(pageType: string) {
    const returnValue: any = {};
    const pagePermissions = routePermissions[pageType];

    for (const pageName in pagePermissions) {
      returnValue[pageName] = pageMap[pageName]?.permissions;
    }

    return returnValue;
  }

  console.log("@user", user);

  return (
    <>
      <Routes>
        {user ? (
          <Route path={"/"} element={<HeaderLayout />}>
            {publicRoutes.map((route) => {
              const canAccess = pageMap[route.pageType]?.canReach;
              return (
                <Route
                  path={route.path}
                  element={
                    canAccess ? (
                      <route.Content
                        //@ts-ignore
                        permissions={getPagePermissions(route.pageType)}
                      />
                    ) : (
                      <ErrorPage />
                    )
                  }
                  key={route.path}
                />
              );
            })}
          </Route>
        ) : (
          <>
            {authRoutes.map((route, idx) => (
              <Route path={route.path} element={<route.Content />} key={idx} />
            ))}
          </>
        )}
      </Routes>
    </>
  );
};

export default ALLRoutes;
